import { createAppSlice } from 'app/createAppSlice'
import moment from 'moment-timezone'
import { getDataCommodities } from './reportPnbpListAction'

const initialState = {
  tag: {
    size: 10,
    page: 0,
  },
  details: null,
  commodities: [],
  loading: false,
  startdate: '',
  enddate: '',
  tagLedger: {
    size: 10,
    page: 0,
  },
  filtersLedger: {
    selectedDate: [
      moment().startOf('month').toDate(),
      moment().endOf('day').toDate(),
    ],
    selectedFilter: { label: 'Semua catatan', value: 'all' },
    selectedYearAnnual: null,
    selectedMonthYear: new Date(),
  },
}

export const configurationsListSlice = createAppSlice({
  name: 'configurationsList',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag.size = payload.size
      state.tag.page = payload.page
    }),
    setFetchOptionLedger: create.reducer((state, { payload }) => {
      state.tagLedger = { ...state.tagLedger, ...payload }
    }),
    setFiltersLedger: create.reducer((state, { payload }) => {
      state.filtersLedger = { ...state.filtersLedger, ...payload }
    }),
    setDateLedger: create.reducer((state, { payload }) => {
      state.startdate = payload.startdate
      state.enddate = payload.enddate
    }),
  }),
  extraReducers: (builder) => {
    builder.addCase(getDataCommodities.fulfilled, (state, { payload }) => {
      state.commodities = payload
      state.loading = false
    })
    builder.addCase(getDataCommodities.pending, (state, { payload }) => {
      state.loading = true
    })
    builder.addCase(getDataCommodities.rejected, (state, { payload }) => {
      state.loading = false
    })
  },
})

export const {
  setFetchOption,
  setFetchOptionLedger,
  setFiltersLedger,
  setDateLedger,
} = configurationsListSlice.actions

export default configurationsListSlice.reducer
